import React from 'react';

const Skills = () => {
  return (
    <section className="Skills" id="Skills">
      <h2 className="heading">My <span>Skills</span></h2>
      <div className="skills-container">
        <div className="skills-box">
          <i className="fa-solid fa-code"></i>
          <h3>Data Analytics & BI</h3>
          <p>Tools: Excel, Power BI, Power Query, DAX, SQL<br/>Core Skills: Data Cleaning, Data Modelling, KPI Calculations<br/>Dashboard Focus: Business Reporting, Operational Insights, Decision Support</p>
          <a href="https://www.linkedin.com/in/damith-wijekoon-06a522216/" className="btn">Read More</a>
        </div>
        <div className="skills-box">
          <i className="fa-solid fa-palette"></i>
          <h3>Logistics & Supply Chain</h3>
          <p>Key Areas: Procurement, Inventory Control, Warehouse Operations<br/>Logistics: Coordination, Transportation, Demand Planning, Order Fulfillment<br/>Focus: Understanding supply chain processes and identifying operational performance gaps.</p>
          <a href="https://www.linkedin.com/in/damith-wijekoon-06a522216/" className="btn">Read More</a>
        </div>
        <div className="skills-box">
          <i className="fa-solid fa-laptop-code"></i>
          <h3>Operations & KPI Reporting</h3>
          <p>Reporting Areas: Stockout Risk, Reorder Analysis, OTIF Performance<br/>Tracking: Backorders, Warehouse Accuracy, Supplier Performance<br/>Skills: KPI Reporting, Performance Monitoring, Risk Identification, Insight Presentation</p>
          <a href="https://www.linkedin.com/in/damith-wijekoon-06a522216/" className="btn">Read More</a>
        </div>

      </div>
    </section>
  );
};

export default Skills;
